import React, { useState } from 'react';
import { IUser } from '../../Interfaces/IUser';
import { IUserGroup } from '../../Interfaces/IUserGroup';
import { useGetLegalRequirementsSmall } from '../../hooks/reactQuerys/LegalRequirementQueries';
import { Card, CardContent, Grid, Typography } from '@mui/material';
import { Checklist } from '@mui/icons-material';
import { AccordionLegend } from './AccordionLegend';
import { RequirementColumn } from './RequirementColumn';

interface IProps {
  userArray: IUser[];
  userGroupArray: IUserGroup[];
}

const ROWS_PER_PAGE = 10;

// idLegalRequirementState: 20 = beim Notar zu prüfen, 15 = bei Mitarbeiter/Gruppe zu prüfen.
// Notar- und Mitarbeiter-Maßnahmen werden getrennt abgefragt und paginiert, damit beide
// Spalten vollständig befüllt sind und nicht über mehrere Seiten "verteilt" erscheinen (#1056).
const STATE_NOTARY = 20;
const STATE_EMPLOYEE = 15;

export const CardRequirementsToCheck: React.FC<IProps> = ({
  userArray,
  userGroupArray,
}) => {
  const [notaryPage, setNotaryPage] = useState(1);
  const [employeePage, setEmployeePage] = useState(1);

  const notary = useGetLegalRequirementsSmall(
    `page=${notaryPage}&ordering=DESC&rowsPerPage=${ROWS_PER_PAGE}&idLegalRequirementState=${STATE_NOTARY}`
  );
  const employee = useGetLegalRequirementsSmall(
    `page=${employeePage}&ordering=DESC&rowsPerPage=${ROWS_PER_PAGE}&idLegalRequirementState=${STATE_EMPLOYEE}`
  );

  return (
    <Card variant='outlined' sx={{ backgroundColor: '#fffde7' }}>
      <CardContent>
        <Grid container alignItems='center'>
          <Grid item sm={8} sx={{ display: 'flex', alignItems: 'center' }}>
            <Checklist sx={{ m: 2, mb: 1, fontSize: 30 }} />
            <Typography>Zu prüfende Maßnahmen im Notarbüro</Typography>
          </Grid>
          <Grid item sm={4}>
            <AccordionLegend />
          </Grid>
        </Grid>

        <Grid container spacing={2}>
          <Grid item sm={6}>
            <RequirementColumn
              title='Notar'
              isNotary={true}
              userArray={userArray}
              userGroupArray={userGroupArray}
              legReqs={notary.legReqs}
              isLoadingLegReqs={notary.isLoadingLegReqs}
              page={notaryPage}
              setPage={setNotaryPage}
              rowsPerPage={ROWS_PER_PAGE}
            />
          </Grid>
          <Grid item sm={6}>
            <RequirementColumn
              title='Mitarbeiter'
              isNotary={false}
              userArray={userArray}
              userGroupArray={userGroupArray}
              legReqs={employee.legReqs}
              isLoadingLegReqs={employee.isLoadingLegReqs}
              page={employeePage}
              setPage={setEmployeePage}
              rowsPerPage={ROWS_PER_PAGE}
            />
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};
